<form class="gap-lg flex flex-col" [formGroup]="form">
  <div hlmField>
    <label for="nom" hlmFieldLabel labelRequired>Nom de la phase</label>
    <input id="nom" hlmInput formControlName="nom" />
    @if (nom.hasError('required') && nom.touched) {
      <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
    }
    @if (nom.hasError('notUnique')) {
      <hlm-field-error>Cette phase existe déjà</hlm-field-error>
    }
  </div>
</form>
